import { Collapse, Flex, Grid, Image, Text } from '@chakra-ui/react'
import { formatPrice } from '../../../utils/formatPrice'

export function CollapseItem({ isExpanded, item }) {
  return (
    <Collapse in={!isExpanded} animateOpacity style={{ width: '100%' }}>
      <Grid
        px="23px"
        py="20px"
        fontSize="13px"
        alignItems="center"
        justifyContent="space-between"
        width="full"
        gridTemplateColumns="200px 302px 196px 275px 1fr"
      >
        <Flex gap={'14px'} alignItems="center" borderRight="1px solid #CFCFCF">
          <Flex alignItems="center" justifyContent="center" w="55px" h="76px" border="1px solid #CFCFCF" borderRadius="10px">
            <Image src={item.imagens_produto[0].url} objectFit="contain" alt="item" boxSize="63px" />
          </Flex>

          <Flex flexDir="column" alignSelf="flex-start" py="9px">
            <Text isTruncated maxW="120px">
              <strong>Cor:</strong> {item.descricao_cor}
            </Text>
            <Text>
              <strong>Impressão:</strong> {item.qtd_batida}
            </Text>
          </Flex>
        </Flex>

        <Flex borderRight="1px solid #CFCFCF" px={'27px'} py="9px" alignItems="start" h="100%" flexDir="column">
          <Text>
            <b>Personalização:</b> {item.nome_personalizacao}
          </Text>
          <Text>
            <b>Prazo:</b> {item.prazo} dias úteis
          </Text>
          <Text>
            <b>Quantidade:</b> {item.quantidade}
          </Text>
        </Flex>

        <Flex borderRight="1px solid #CFCFCF" px={'27px'} py="9px" alignItems="start" h="100%" flexDir="column">
          <Text>
            <b>Preço site:</b> {item.preco_site}
          </Text>
          <Text>
            <b>Preço de tabela:</b> {item.preco_base}
          </Text>
        </Flex>
        <Flex borderRight="1px solid #CFCFCF" px={'27px'} py="9px" alignItems="start" h="100%" flexDir="column">
          <Text>
            <b>Substituição tributária:</b> {item.vlr_substituicao}
          </Text>
          <Text>
            <b>Preço venda:</b> {item.preco_venda}
          </Text>
        </Flex>
        <Flex px={'27px'} py="9px" alignItems="start" h="100%" flexDir="column">
          <Text>
            <b>Valor total dos itens:</b> {item.valor_total_itens}
          </Text>
          <Text>
            <b>Preço do frete:</b> {formatPrice(item.transportadora?.valor_simulacao || 0)}
          </Text>
          <Text>
            <b>Valor total:</b> {item.valor_total_itens}
          </Text>
        </Flex>
      </Grid>
    </Collapse>
  )
}
